import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Banner = styled.div`
  position: fixed;
  left: 1rem;
  right: 1rem;
  bottom: 1rem;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.18);
  border: 1px solid #e5e7eb;
  padding: 1rem 1.25rem;
  z-index: 3500;

  @media (min-width: 768px) {
    left: auto;
    right: 1.5rem;
    bottom: 1.5rem;
    max-width: 520px;
  }
`;

const Message = styled.p`
  margin: 0;
  color: #111827;
  font-size: 0.95rem;
  line-height: 1.45;
`;

const SubMessage = styled.p`
  margin: 0.5rem 0 0;
  color: #4b5563;
  font-size: 0.85rem;
  line-height: 1.45;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 0.9rem;
`;

const PrimaryButton = styled.button`
  border: none;
  border-radius: 999px;
  padding: 0.55rem 1.1rem;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  color: #ffffff;
  background: linear-gradient(135deg, #16a34a, #2563eb);
`;

const SecondaryButton = styled.button`
  border: 1px solid #d1d5db;
  border-radius: 999px;
  padding: 0.55rem 1.1rem;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  color: #374151;
  background: #f9fafb;
`;

const PolicyLink = styled(Link)`
  color: #2563eb;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  align-self: center;

  &:hover {
    text-decoration: underline;
  }
`;

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const existing = window.localStorage.getItem('cookie_consent');
    if (!existing) {
      setVisible(true);
    }
  }, []);

  const acceptAll = () => {
    window.localStorage.setItem('cookie_consent', 'all');
    setVisible(false);
  };

  const acceptNecessary = () => {
    window.localStorage.setItem('cookie_consent', 'necessary');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Banner role="dialog" aria-live="polite" aria-label="Çerez bildirimi">
      <Message>Web sitemizde deneyiminizi geliştirmek ve analiz yapmak için çerezler kullanıyoruz.</Message>
      <SubMessage>
        Zorunlu çerezler sitenin çalışması için gereklidir. Analitik ve pazarlama çerezleri yalnızca
        onayınızla kullanılır.
      </SubMessage>
      <Actions>
        <PrimaryButton type="button" onClick={acceptAll}>
          Tümünü Kabul Et
        </PrimaryButton>
        <SecondaryButton type="button" onClick={acceptNecessary}>
          Sadece Zorunlu Çerezler
        </SecondaryButton>
        <PolicyLink to="/cerez-politikasi">Çerez Politikası</PolicyLink>
      </Actions>
    </Banner>
  );
};

export default CookieBanner;
